import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const role = user?.roleName?.toLowerCase();
  const landing =
    role === "support" ? "/School-Support" : role === "sales" || role === "salesandsupport" ? "/School-Lead" : ROUTES.HOME;

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant="h4" gutterBottom margin={0}>Not Authorized</Typography>
      <Typography>You don't have permission to view this page.</Typography>
      <Button variant="contained" onClick={() => navigate(landing, { replace: true })}>Go Back</Button>
    </Box>
  );
};

export default Unauthorized;
